import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiHttpClient } from 'app/http/clients/api';
import { environment } from 'environments/environment';
import { BorrowerLoan } from 'app/models/dto/borrower-loan.model';
const baseUrl = `${environment.API_URL}/borrower-loan`;

@Injectable({
  providedIn: 'root'
})
export class BorrowerLoansService {

  constructor(private http: ApiHttpClient) { }

  get(borrowerId: number): Observable<BorrowerLoan[]> {
    return this.http.get<BorrowerLoan[]>(`${baseUrl}/${borrowerId}`);
  }

  update(borrowerId: number, updates: any): Observable<BorrowerLoan[]> {
    return this.http.put<BorrowerLoan[]>(`${baseUrl}/${borrowerId}`, updates);
  }
}
